/**
 * Root Container
 */

import '../components/styles/root.scss';

import { configureStore } from '../redux';
import { environment as relayEnvironment } from '../relay';
import Router from '../router';
import routeConfig from '../router/RouteConfig';

import { Resolver } from 'found-relay';
import * as React from 'react';
import { Provider } from 'react-redux';

class Root extends React.Component<{}, {}> {
  private store;

  constructor(props) {
    super(props);
    this.store = configureStore(routeConfig);
  }

  render() {
    return (
      <Provider store={this.store}>
        <Router matchContext={{ store: this.store }} resolver={new Resolver(relayEnvironment)} />
      </Provider>
    );
  }
}

export default Root;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/containers/Root.tsx